import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Field } from '../fields/Field';
import { theme } from '../theme';
import { useUniqueId } from '../utils/id';
export const Textarea = forwardRef(function Textarea({ id: idProp, name, value, onChange, onInputChange, resize = 'none', error = false, placeholder, disabled = false, maxLength, onBlur, rows = 4, fallbackStyle, ...fieldProps }, ref) {
    const id = useUniqueId(idProp);
    return (React.createElement(Field, { ...fieldProps, htmlFor: id, error: error },
        React.createElement(StyledTextArea, { ref: ref, "$error": error, id: id, name: name, disabled: disabled, "$resize": resize, "$fallbackStyle": fallbackStyle, placeholder: placeholder, value: value, onChange: (e) => {
                onChange?.(e.currentTarget.value);
                onInputChange?.(e);
            }, maxLength: maxLength, onBlur: onBlur, rows: rows })));
});
const StyledTextArea = styled.textarea `
  font-size: 16px;
  font: inherit;
  line-height: 20px;
  background: ${({ $fallbackStyle }) => $fallbackStyle ? theme.colors.custard : theme.colors.cream};
  border: 2px solid ${theme.colors.oatmeal};
  box-sizing: border-box;
  border-radius: 12px;
  width: 100%;
  padding: 18px 14px;
  color: ${theme.colors.liquorice};
  resize: ${({ $resize }) => $resize};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'text')};
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
  border-color: ${({ $error }) => theme.colors[`${$error ? 'strawberry' : 'oatmeal'}`]};
  outline: none;

  &:hover,
  &:focus,
  &:focus-visible {
    border-color: ${({ $error }) => $error ? theme.colors.strawberry : theme.colors.marzipan};
  }
`;
//# sourceMappingURL=Textarea.js.map